"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "customers.selectionCustomers";
  var componentName = "selectCustomers";

  var bindings = {
    selectedIds: "="
  };

  var templateUrl = "app/pages/customers/selectionCustomers/selectionCustomers.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $rootScope, $timeout, CustomersService, AgGridService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$timeout = $timeout;
      this.AgGridService = AgGridService;
      this.CustomersService = CustomersService;

      this.columnDefs = [this.AgGridService.text("name", "Nom du client"), AgGridService.button("btDelete", "Retirer", this.delete, this, {
        width: 90
      })];
    }

    _createClass(Controller, [{
      key: "envChanged",
      value: function envChanged(evt) {
        console.log(evt);
        var index = this.selectedIds.indexOf(this.selectedCustomer.value);

        if (index == -1) {
          this.selectedIds.push(this.selectedCustomer.value);
          this.updateTable();
        }
      }
    }, {
      key: "addAll",
      value: function addAll() {
        this.selectedIds = this.customerArray.map(function (customer) {
          return customer.value;
        });
        this.updateTable();
      }
    }, {
      key: "removeAll",
      value: function removeAll() {
        this.selectedIds = [];
        this.updateTable();
      }
    }, {
      key: "delete",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(row, ctx) {
          var deleteElement, index;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return swal({
                    title: "Voulez-vous retirer le client " + row.name + " ?",

                    icon: "warning",
                    dangerMode: true,

                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteElement = _context.sent;


                  if (deleteElement) {
                    index = ctx.selectedIds.indexOf(row.value);


                    if (index > -1) {
                      ctx.selectedIds.splice(index, 1);
                      ctx.updateTable();
                    }
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function _delete(_x, _x2) {
          return _ref.apply(this, arguments);
        }

        return _delete;
      }()
    }, {
      key: "updateTable",
      value: function updateTable() {
        var _this = this;

        if (this.selectedIds) {
          console.log(this.selectedCustomer);
          var selectedCustomers = [];

          for (var indexCustomer = 0; indexCustomer < this.selectedIds.length;) {
            var customerId = this.selectedIds[indexCustomer];
            var customer = this.customerArray.find(function (el) {
              return el.value === customerId;
            });

            if (customer) {
              customer.btDelete = {
                text: '<i class="fa fa-eraser"></i> Retirer',
                color: "custom"
              };
              selectedCustomers.push(customer);
              indexCustomer++;
            } else {
              console.log("no customer for " + customerId);
              this.selectedIds.splice(indexCustomer, 1);
            }
          }

          this.rawData = selectedCustomers;

          this.$timeout(function () {
            _this.needToBeUpdate = true;
          });
        } else {
          this.selectedIds = [];
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2 = this;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.CustomersService.getSelectArray();

                case 2:
                  this.customerArray = _context2.sent;


                  // Le client LVR n'est pas sélectionnable pour éviter de fausser le calcul des stats DEPA (délai de prise de RDV) qui est basé sur le client LVR
                  this.customerArray = this.customerArray.filter(function (customer) {
                    return customer.active == true && customer.name !== "LVR";
                  });

                  this.$scope.$watch(function () {
                    return _this2.selectedIds;
                  }, function () {
                    console.log("this.selectedIds", _this2.selectedIds);
                    _this2.updateTable();
                  });

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function $onInit() {
          return _ref2.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    //transclude: true,
    controller: Controller
  });
})();